// ImagePopup.js
import React from "react";
import { Modal, Button } from "react-bootstrap";

function ImagePopup({ imageUrl, label, show, onClose }) {
  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{label || "Preview"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <img
          src={imageUrl}
          alt="Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "70vh",
            cursor: "zoom-in",
            transition: "transform 0.3s ease-in-out",
          }}
          onClick={(e) => {
            e.target.style.transform =
              e.target.style.transform === "scale(2)" ? "scale(1)" : "scale(2)";
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ImagePopup;
